<template>
  <div
    v-if="chartComponent"
    class="fill-height"
  >
    <component
      :is="chartComponent"
      :players="chartData"
      :aggregation="chart.aggregation"
      :removable="removable"
      @remove="$emit('remove')"
    />
  </div>
</template>

<script>
import SprintHsrChart from '@/components/charts/implementation/SprintHsrChart.vue'
import TotalDistHsrChart from '@/components/charts/implementation/TotalDistHsrChart.vue'
import ExplosiveHsrMinChart from '@/components/charts/implementation/ExplosiveHsrMinChart.vue'
import RpeTtmAcuteLoadChart from '@/components/charts/implementation/RpeTtmAcuteLoadChart.vue'
import RpeTtmChronicLoadChart from '@/components/charts/implementation/RpeTtmChronicLoadChart.vue'
import SleepStatusChart from '@/components/charts/implementation/SleepStatusChart.vue'
import MoodStressChart from '@/components/charts/implementation/MoodStressChart.vue'
import GeneralMuscleSorenessChart from '@/components/charts/implementation/GeneralMuscleSorenessChart.vue'

export default {
  name: 'TeamLoadChart',
  components: {
    SprintHsrChart,
    TotalDistHsrChart,
    ExplosiveHsrMinChart,
    RpeTtmAcuteLoadChart,
    RpeTtmChronicLoadChart,
    SleepStatusChart,
    MoodStressChart,
    GeneralMuscleSorenessChart
  },
  props: {
    players: {
      type: Array,
      required: true
    },
    removable: {
      type: Boolean,
      default: false
    },
    chart: {
      type: Object,
      required: true
    },
    minMaxValues: {
      type: Object,
      default: () => ({
        minValues: {},
        maxValues: {}
      })
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    chartComponent() {
      const componentMap = {
        SPRINT_HSR: 'SprintHsrChart',
        TOTAL_DIST_HSR: 'TotalDistHsrChart',
        EXPLOSIVE_HSR_MIN: 'ExplosiveHsrMinChart',
        RPE_TTM_ACUTE: 'RpeTtmAcuteLoadChart',
        RPE_TTM_CHRONIC: 'RpeTtmChronicLoadChart',
        SLQ_SLD: 'SleepStatusChart',
        MOO_STL: 'MoodStressChart',
        GMS: 'GeneralMuscleSorenessChart'
      }

      return componentMap[this.chart.key] || null
    },

    chartData() {
      if (['SPRINT_HSR', 'TOTAL_DIST_HSR', 'EXPLOSIVE_HSR_MIN', 'SLQ_SLD', 'MOO_STL', 'GMS'].includes(this.chart.key)) {
        return this.players
      }

      if (['RPE_TTM_ACUTE', 'RPE_TTM_CHRONIC'].includes(this.chart.key)) {
        return {
          data: this.players,
          minValues: this.minMaxValues.minValues || {},
          maxValues: this.minMaxValues.maxValues || {}
        }
      }

      return this.players
    }
  }
}
</script>
